import axios from "axios";
import { config } from "../utils/config";
import { apiErrorHandler } from "./apiErrorHandler";
// import { loadProgressBar } from 'x-axios-progress-bar'

// loadProgressBar()

export const BaseUrl = {
  Api: window._env_?.REACT_APP_API_BASE_URL,
};

export function setAuthHeader(token) {
  axios.defaults.headers.common["Authorization"] = token
    ? "Bearer " + token
    : "";
}

export function setApiKey() {
  axios.defaults.headers.common["InternalApiKey"] = window._env_
    ?.REACT_APP_INTERNAL_API_KEY
    ? window._env_?.REACT_APP_INTERNAL_API_KEY
    : "";
}

export const convertToi18nLanguage = (languageCode) => {
  switch (languageCode) {
    case "en":
    case "en-US":
      return "en-US";
    case "nb":
    case "nb-NO":
      return "nb-NO";
    case "sv":
    case "sv-SE":
      return "sv-SE";
    default:
      return "en-US";
  }
};

export function setAcceptLanguageHeader(language) {
  axios.defaults.headers.common["Accept-Language"] = language;
}

const readResponseHeaders = (headers) => {
  const exchangeHeader = headers["xauthorization-exchange-token"];

  if (exchangeHeader) {
    sessionStorage.setItem("document-token", exchangeHeader);
    setAuthHeader(exchangeHeader);
  }
};

/**
 * @param {string} path
 * @param {string} baseUrl
 * @param {ApiOptions} options
 */
export const get = async (
  path,
  baseUrl = window._env_?.REACT_APP_API_BASE_URL,
  options = null,
) => {
  const axiosParams = options?.axiosParams || {};
  try {
    const result = await axios({
      method: "get",
      url: `${baseUrl}/${path}`,
      progress: options?.axiosParams?.showProgressBar ? true : false,
      ...axiosParams,
    });
    readResponseHeaders(result.headers);

    return result.data;
  } catch (err) {
    await apiErrorHandler(err, options?.statusCodeHandlers);
  }
};

/**
 * @param {string} path
 * @param {object} data
 * @param {ApiOptions} options
 * @param {string} baseUrl
 * @returns
 */
export const put = async (
  path,
  baseUrl = window._env_?.REACT_APP_API_BASE_URL,
  data,
  options = null,
) => {
  const axiosParams = options?.axiosParams || {};
  try {
    const result = await axios({
      method: "put",
      url: `${baseUrl}/${path}`,
      progress: options?.axiosParams?.showProgressBar ? true : false,
      data,
      ...axiosParams,
    });
    return result.data;
  } catch (err) {
    await apiErrorHandler(err, options?.statusCodeHandlers);
  }
};

/**
 * @param {string} path
 * @param {Object} data
 * @param {ApiOptions} options
 * @param {string} baseUrl
 * @returns
 */
export const post = async (
  path,
  baseUrl = window._env_?.REACT_APP_API_BASE_URL,
  data,
  options = null,
) => {
  const axiosParams = options?.axiosParams || {};
  try {
    const result = await axios({
      method: "post",
      url: `${baseUrl}/${path}`,
      progress: options?.axiosParams?.showProgressBar ? true : false,
      data,
      ...axiosParams,
    });
    return result.data;
  } catch (err) {
    await apiErrorHandler(err, options?.statusCodeHandlers);
  }
};

/**
 * @param {string} path
 * @param {ApiOptions} options
 * @param {string} baseUrl
 * @returns
 */
export const destroy = async (
  path,
  baseUrl = window._env_?.REACT_APP_API_BASE_URL,
  options = null,
) => {
  const axiosParams = options?.axiosParams || {};
  try {
    const result = await axios({
      method: "delete",
      url: `${baseUrl}/${path}`,
      progress: options?.axiosParams?.showProgressBar ? true : false,
      ...axiosParams,
    });
    return result.data;
  } catch (err) {
    await apiErrorHandler(err, options?.statusCodeHandlers);
  }
};
